import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateField } from "../../../reduxSlice/profileSlice";

export const validateStep4 = (data) => {
    const errors = {};
    const alphabetRegex = /^[A-Za-z.\s]+$/;

    // Highest Education Validation
    if (!data.highestEducation?.trim()) {
        errors.highestEducation = "Highest education stream required";
    }
    if (data.highestEducation?.toLowerCase() === "others" && !data.highestEducationOther?.trim()) {
        errors.highestEducationOther = "Please specify your highest education stream";
    }

    // Second Highest Education Validation
    if (!data.secondHighestEducation?.trim()) {
        errors.secondHighestEducation = "Second highest education stream required";
    }
    if (data.secondHighestEducation?.toLowerCase() === "others" && !data.secondHighestEducationOther?.trim()) {
        errors.secondHighestEducationOther = "Please specify your second highest education stream";
    }

    if (!data.jobType) errors.jobType = "Occupation is required";

    // Education Specialization validation (Alphabets only & Max 50 characters)
    if (data.specialization?.trim()) {
        if (!alphabetRegex.test(data.specialization)) {
            errors.specialization = "Specialization must contain alphabets only";
        } else if (data.specialization.length > 50) {
            errors.specialization = "Specialization cannot exceed 50 characters";
        }
    }

    const jobTypeLower = (data.jobType || "").toLowerCase();
    const isNotWorking = jobTypeLower === "not working" || jobTypeLower === "searching for job";

    if (!isNotWorking) {
        if (data.income === "" || data.income === undefined || data.income === null) {
            errors.income = "Income is required";
        } else if (isNaN(data.income)) {
            errors.income = "Enter a valid numeric income";
        } else if (Number(data.income) <= 0) {
            errors.income = "Income must be greater than 0";
        }

        if (!data.workLocation?.trim()) errors.workLocation = "Work/Business/Agricultural Location required";
    }

    return errors;
};

const Step4EducationProfession = ({ masters = {} }) => {
    const dispatch = useDispatch();
    const formData = useSelector((state) => state.profile);
    const errors = useSelector((state) => state.profile.errors || {});

    const educationOptions = masters.EducationMaster || [];
    const currentStep = formData.currentStep;
    const jobTypeLower = (formData.jobType || "").toLowerCase();
    const isNotWorking = jobTypeLower === "not working" || jobTypeLower === "searching for job";
    const isAgriculture = jobTypeLower === "agriculture";

    const highestEdu = formData.highestEducation || "";
    const secondEdu = formData.secondHighestEducation || "";

    useEffect(() => {
        if (currentStep === 4) {
            let errorsUpdates = {};
            let updateRequired = false;

            if (isNotWorking && (formData.organizationName || formData.occupation || formData.designation || formData.income || formData.workLocation)) {
                dispatch(updateField({ field: "organizationName", value: "" }));
                //dispatch(updateField({ field: "occupation", value: "" }));
                dispatch(updateField({ field: "designation", value: "" }));
                dispatch(updateField({ field: "income", value: "" }));
                dispatch(updateField({ field: "workLocation", value: "" }));

                errorsUpdates = {
                    ...errorsUpdates,
                    organizationName: "",
                    //occupation: "",
                    designation: "",
                    income: "",
                    workLocation: ""
                };
                updateRequired = true;
            }

            if (isAgriculture && (formData.organizationName || formData.designation)) {
                dispatch(updateField({ field: "organizationName", value: "" }));
                dispatch(updateField({ field: "designation", value: "" }));

                errorsUpdates = {
                    ...errorsUpdates,
                    organizationName: "",
                    designation: ""
                };
                updateRequired = true;
            }

            if (highestEdu.toLowerCase() !== "others" && formData.highestEducationOther) {
                dispatch(updateField({ field: "highestEducationOther", value: "" }));
                errorsUpdates.highestEducationOther = "";
                updateRequired = true;
            }

            if (secondEdu.toLowerCase() !== "others" && formData.secondHighestEducationOther) {
                dispatch(updateField({ field: "secondHighestEducationOther", value: "" }));
                errorsUpdates.secondHighestEducationOther = "";
                updateRequired = true;
            }

            if (updateRequired) {
                dispatch(updateField({
                    field: "errors",
                    value: {
                        ...errors,
                        ...errorsUpdates
                    }
                }));
            }
        }
    }, [currentStep, isNotWorking, isAgriculture, highestEdu, secondEdu, dispatch]);

    const filteredSecondEducationOptions = educationOptions.filter(
        (opt) => opt.name.toLowerCase() !== (formData.highestEducation || "").toLowerCase()
    );

    const jobOptions = masters.JobMaster && masters.JobMaster.length > 0
        ? masters.JobMaster
        : [
            { name: "Private Sector" },
            { name: "Government" },
            { name: "Business / Self Employed" },
            { name: "Not Working" }
        ];

    const handleInputChange = (field, value) => {
        let finalValue = value;

        if (field === "specialization") {
            finalValue = finalValue.replace(/[^A-Za-z\s]/g, "");
        } else if (field === "income") {
            finalValue = finalValue.replace(/[^0-9]/g, "");
        }

        const dropdownFields = ["jobType", "highestEducation", "secondHighestEducation"];

        if (!dropdownFields.includes(field) && field !== "income" && typeof finalValue === "string" && finalValue.length > 0) {
            finalValue = finalValue.charAt(0).toUpperCase() + finalValue.slice(1);
        }

        dispatch(updateField({ field, value: finalValue }));

        const simulatedData = { ...formData, [field]: finalValue };
        const generatedErrors = validateStep4(simulatedData);

        dispatch(updateField({
            field: "errors",
            value: {
                ...errors,
                [field]: generatedErrors[field] || ""
            }
        }));
    };

    return (
        <div className="form-animate">
            <div className="row">
                {/* Highest Education */}
                <div className="col-md-12">
                    <div className="inputcontainer mb-3">
                        <h5 className="input_label">Highest Education Stream/Field<span className="m_feild">*</span></h5>
                        {educationOptions.length > 0 ? (
                            <select
                                className={`form-select input_style ${errors.highestEducation ? "is-invalid" : ""}`}
                                value={formData.highestEducation || ""}
                                onChange={(e) => {
                                    handleInputChange("highestEducation", e.target.value);
                                    if (e.target.value === formData.secondHighestEducation) {
                                        handleInputChange("secondHighestEducation", "");
                                    }
                                }}
                            >
                                <option value="">Select Education Level</option>
                                {educationOptions.map((opt, i) => (
                                    <option key={i} value={opt.name}>{opt.name}</option>
                                ))}
                                <option value="Others">Others</option>
                            </select>
                        ) : (
                            <input className={`form-control input_style ${errors.highestEducation ? "is-invalid" : ""}`} placeholder="E.g. Engineering, Commerce" value={formData.highestEducation || ""} onChange={(e) => handleInputChange("highestEducation", e.target.value)} />
                        )}
                        {errors.highestEducation && <div className="text-danger small mt-1">{errors.highestEducation}</div>}
                    </div>
                </div>

                {/* Dynamic Input field for Highest Education "Others" */}
                {formData.highestEducation?.toLowerCase() === "others" && (
                    <div className="col-md-12">
                        <div className="inputcontainer mb-3">
                            <h5 className="input_label">Specify Highest Education Stream<span className="m_feild">*</span></h5>
                            <input
                                className={`form-control input_style ${errors.highestEducationOther ? "is-invalid" : ""}`}
                                placeholder="Enter your Highest Education Stream"
                                value={formData.highestEducationOther || ""}
                                onChange={(e) => handleInputChange("highestEducationOther", e.target.value)}
                            />
                            {errors.highestEducationOther && <div className="text-danger small mt-1">{errors.highestEducationOther}</div>}
                        </div>
                    </div>
                )}

                {/* Second Highest Education */}
                <div className="col-md-12">
                    <div className="inputcontainer mb-3">
                        <h5 className="input_label">Second Highest Education Stream/Field<span className="m_feild">*</span></h5>
                        {educationOptions.length > 0 ? (
                            <select className={`form-select input_style ${errors.secondHighestEducation ? "is-invalid" : ""}`} value={formData.secondHighestEducation || ""} onChange={(e) => handleInputChange("secondHighestEducation", e.target.value)}>
                                <option value="">Select Education Level</option>
                                {filteredSecondEducationOptions.map((opt, i) => (
                                    <option key={i} value={opt.name}>{opt.name}</option>
                                ))}
                                <option value="Others">Others</option>
                            </select>
                        ) : (
                            <input className={`form-control input_style ${errors.secondHighestEducation ? "is-invalid" : ""}`} placeholder="Second Degree (If Any)" value={formData.secondHighestEducation || ""} onChange={(e) => handleInputChange("secondHighestEducation", e.target.value)} />
                        )}
                        {errors.secondHighestEducation && <div className="text-danger small mt-1">{errors.secondHighestEducation}</div>}
                    </div>
                </div>

                {/* Dynamic Input field for Second Highest Education "Others" */}
                {formData.secondHighestEducation?.toLowerCase() === "others" && (
                    <div className="col-md-12">
                        <div className="inputcontainer mb-3">
                            <h5 className="input_label">Specify Second Highest Education Stream<span className="m_feild">*</span></h5>
                            <input
                                className={`form-control input_style ${errors.secondHighestEducationOther ? "is-invalid" : ""}`}
                                placeholder="Enter your Second Highest Education Stream"
                                value={formData.secondHighestEducationOther || ""}
                                onChange={(e) => handleInputChange("secondHighestEducationOther", e.target.value)}
                            />
                            {errors.secondHighestEducationOther && <div className="text-danger small mt-1">{errors.secondHighestEducationOther}</div>}
                        </div>
                    </div>
                )}

                {/* Education Specialization */}
                <div className="col-md-12">
                    <div className="inputcontainer mb-3">
                        <h5 className="input_label">Education Specialization</h5>
                        <input
                            className={`form-control input_style ${errors.specialization ? "is-invalid" : ""}`}
                            maxLength="50"
                            placeholder="Computer Science, Finance etc (Alphabets only, max 50 characters)"
                            value={formData.specialization || ""}
                            onChange={(e) => handleInputChange("specialization", e.target.value)}
                        />
                        {errors.specialization && <div className="text-danger small mt-1">{errors.specialization}</div>}
                    </div>
                </div>

                {/* Job Type */}
                <div className="col-md-6">
                    <div className="inputcontainer mb-3">
                        <h5 className="input_label">Occupation<span className="m_feild">*</span></h5>
                        <select
                            className={`form-select input_style ${errors.jobType ? "is-invalid" : ""}`}
                            value={formData.jobType || ""}
                            onChange={(e) => handleInputChange("jobType", e.target.value)}
                        >
                            <option value="">Select Job Type</option>
                            {jobOptions.map((opt, i) => (
                                <option key={i} value={opt.value || opt.name}>{opt.name}</option>
                            ))}
                        </select>
                        {errors.jobType && <div className="text-danger small mt-1">{errors.jobType}</div>}
                    </div>
                </div>

                {/* Conditional Professional Fields Group */}
                {!isNotWorking && (
                    <>
                        {/* Organization Name */}
                        {!isAgriculture && (
                        <div className="col-md-6">
                            <div className="inputcontainer mb-3">
                                <h5 className="input_label">Organization Name</h5>
                                <input className="form-control input_style" placeholder="Enter Company Name" value={formData.organizationName || ""} onChange={(e) => handleInputChange("organizationName", e.target.value)} />
                            </div>
                        </div>
                        )}

                        {/* Occupation */}
                        {/*<div className="col-md-6">
                            <div className="inputcontainer mb-3">
                                <h5 className="input_label">Occupation</h5>
                                <input className="form-control input_style" placeholder="Enter Occupation" value={formData.occupation || ""} onChange={(e) => handleInputChange("occupation", e.target.value)} />
                            </div>
                        </div>*/}

                        {/* Designation */}
                        {!isAgriculture && (
                        <div className="col-md-6">
                            <div className="inputcontainer mb-3">
                                <h5 className="input_label">Designation</h5>
                                <input className="form-control input_style" placeholder="Enter Designation" value={formData.designation || ""} onChange={(e) => handleInputChange("designation", e.target.value)} />
                            </div>
                        </div>
                        )}

                        {/* Income */}
                        <div className="col-md-6">
                            <div className="inputcontainer mb-3">
                                <h5 className="input_label">Income (per annum)<span className="m_feild">*</span></h5>
                                <div className="position-relative">
                                    <input className={`form-control input_style ${errors.income ? "is-invalid" : ""}`} placeholder="Enter Income" value={formData.income || ""} onChange={(e) => handleInputChange("income", e.target.value)} />
                                    <div className="kg_txt">INR</div>
                                </div>
                                {errors.income && <div className="text-danger small mt-1">{errors.income}</div>}
                            </div>
                        </div>

                        {/* Work Location */}
                        <div className="col-md-6">
                            <div className="inputcontainer mb-3">
                                <h5 className="input_label">Work/Business/Agricultural Location<span className="m_feild">*</span></h5>
                                <input className={`form-control input_style ${errors.workLocation ? "is-invalid" : ""}`} placeholder="Enter City" value={formData.workLocation || ""} onChange={(e) => handleInputChange("workLocation", e.target.value)} />
                                {errors.workLocation && <div className="text-danger small mt-1">{errors.workLocation}</div>}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Step4EducationProfession;